import React, { useState, Fragment, useRef, useContext, useEffect } from 'react';
import ReactModal from 'react-modal';
import { NavLink, useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { BlobParam } from '../../utils/SiteTools';
import CategoryDemoContext from '../../utils/CategoryDemo/context';
import BankingTypeContext from '../../utils/BankingType/context';
import Modal from '../Modal/Modal';

import { loadPageView } from '../../utils/Tealium';
import { targetLOB, lobRoot, lobDemoSplit } from "../../utils/LobLogicModule";

import * as MODALS from '../../constants/modals';
import * as SELECTORS from '../../constants/selectors';
import './NavigationModal.scss';

/**
 * NavigationModal component
 * Manages the global menu of the page. This component is used by the Header And the Navigation Sticky Components
 */
const NavigationModal = ({ id }) => {
    ReactModal.setAppElement('#root');
    ReactModal.defaultStyles.overlay.backgroundColor = MODALS.DARK_BACKGROUND;
    ReactModal.defaultStyles.overlay.zIndex = 10;

    const menuRef = useRef();
    const { categoryDemoData } = useContext(CategoryDemoContext);
    const { t, i18n } = useTranslation('navigation_modal');
    const [modalIsOpen, setIsOpen] = useState(false);
    const LOB = targetLOB;
    const demoCatNameSs = sessionStorage.getItem('demoCatName');
    const { search } = useLocation();
   /* This is to set the currentUrl to the current page. */
    let currentUrl = useLocation().pathname.split('/')[LOB];
    currentUrl = (currentUrl !== '' && typeof(currentUrl) !== "undefined") ? currentUrl : 'homepage';
    const location = useLocation();
    const { bankingType } = useContext(BankingTypeContext);
    const demoType = (bankingType === SELECTORS.OLB) ? SELECTORS.ONLINE_DEMO : SELECTORS.MOBILE_DEMO;
    const history = useHistory();
    
    useEffect(() => {
        return history.listen((location) => {
            if((location.pathname === '/' && history.action !== 'POP' && history.action !== 'PUSH') || (location.pathname === '/' && location.state === 'fromErrorDB') ){
                window.location = '/';
                window.location.reload();
            } 
            if( ((location.pathname === '/sb' || location.pathname === '/sb/') && history.action !== 'POP' && history.action !== 'PUSH') || (location.pathname === '/sb' || location.state === 'fromErrorSB') ){
                window.location = '/sb/smallbusiness';
                window.location.reload();
            }
            if( (location.pathname === '/fc' || location.pathname === '/fc/') && history.action !== 'POP' && history.action !== 'PUSH'){
                setTimeout(() => {
                window.location = '/fc'; 
                window.location.reload();
                }, 1000);
            }
            if( (location.pathname === '/ml' || location.pathname === '/ml/') && history.action !== 'POP' && history.action !== 'PUSH'){
                setTimeout(() => {
                window.location = '/ml'; 
                window.location.reload();
                }, 1000);
            }
            if( ((location.pathname === '/privatebank' || location.pathname === '/privatebank/') && history.action !== 'POP' && history.action !== 'PUSH') ){
                setTimeout(() => {
                    window.location = '/privatebank'; 
                    window.location.reload();
                }, 1000);
            }
        }) 
     },[history]);

    /**
    * this useEffect is for tagging
    */
    useEffect(() => {
        function getIndex(items) {
            for (const [index, item] of items.entries()) {
                if (currentUrl === 'homepage') {
                    sessionStorage.setItem('demoCatName', '');
                    return 0;
                } else if (item === location.pathname.match(/\/([^/]+)\/?$/)[1]) {
                    return index;
                } 
            }
        }

        const waitPageTags = () => {
            if(sessionStorage.getItem("pageNameTags") !== null) {
                const pageTags = JSON.parse(sessionStorage.getItem('pageNameTags')); // this is used for tagging
                loadPageView(getIndex(pageTags));
            }
            else{
                setTimeout(waitPageTags, 250);
            }
        }
        waitPageTags();

      /*eslint-disable */
    }, [location]);


    /**
     * @method openModal
     * Opens Modal window
     */
    const openModal = () => {
        setIsOpen(true);
        menuRef.current.setAttribute('aria-expanded', 'true');
        // this is a temporary code for non default category
        // into a different LOB
        setTimeout(() => {
            if(!document.querySelector('.nav-item.active')){
                document.querySelector('.navs').classList.add('homepage');
            }
            window.bactm.rescanDOM();
        }, 150);
    };

    /**
     * @method closeModal
     * Closes Modal window
     */
    const closeModal = () => {
        setIsOpen(false);
        menuRef.current.setAttribute('aria-expanded', 'false');
    };

    /**
     * @method movePagetoTop
     * Makes the page go to the upper position when a tile is clicked.
     */
    const movePagetoTop = () => {
        closeModal();
        window.scrollTo(0, 0);
        document.getElementById('skip').focus();
    };

    /**
     * @method openSubNav
     * Open sub navigation
     */
    const openSubNav = e => {
        if (e.target.classList.contains('home')){
            movePagetoTop();
            return;
        } 

        const targetEl = e.target.parentNode;
        const parentEl = targetEl.parentNode;
        const subNav = targetEl.querySelector('.subnav');

        parentEl.className = 'navs';
        targetEl.classList.add('active');
        subNav && subNav.setAttribute('aria-hidden', 'false');

        movePagetoTop();
    }

    /**
     * @method showHomeMenu
     * Change Navigation back to parent navigation
     */
    const showHomeMenu = e => {
        // AP: Because IE11 selects wrong target by default compare to other browsers...
        const parentEl = e.target.className !== "back-to-parent" ? e.target.parentNode : e.target;
        const targetEl = parentEl.parentNode.parentNode;
        const subNav = parentEl.parentNode.querySelector('.subnav');

        targetEl.className = 'navs homepage';
        targetEl.querySelector('.nav-item .pageNavLink.home').classList.remove('active');
        targetEl.querySelectorAll('.nav-item').forEach(item => item.classList.remove('active'));
        subNav && subNav.setAttribute('aria-hidden', 'true');
    }

    return (
        <Fragment>
            <button ref={menuRef} id={id} data-component="Navigation" className="button-link-style cta_hamburger t-track-custom" aria-label={t('navigation_modal.button.label')} aria-haspopup="true" aria-expanded="false" onClick={openModal} data-bactmln="Navigation-_-Click-_-Menu">
                <span className="hamburger"></span>
                <span className="hamburger"></span>
                <span className="hamburger"></span>
            </button>
            <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal} shouldCloseOnOverlayClick={MODALS.DEFAULT_CLOSE_BEHAVIOR} style={MODALS.NAVIGATION_STYLES} aria={{ label: t('navigation_modal.button.menu_label') }}>

                <div id="navPopup" className="navigation-modal" tabIndex="-1">
                    <div className="nav_items" role="document">
                        <button autoFocus id="Btn_Close" data-component="Navigation" className="cta_close button-link-style t-track-custom" aria-label={t('navigation_modal.button.close_alt')} onClick={closeModal} data-bactmln="Navigation-_-Click-_-Close">
                            <img src={`${process.env.PUBLIC_URL}/assets/icons/close.svg`} alt={t('navigation_modal.button.close_alt')} />
                        </button>
                        <ul className={`navs ${currentUrl}`}>
                            <li className={`nav-item${currentUrl === '/' ? ' active' : ''}`}>
                                <img className="icon_home" src={`${process.env.PUBLIC_URL}/assets/icons/icon_home.svg`} alt="" />
                                {i18n.language === 'es' ? <Modal url={`${process.env.PUBLIC_URL}`+lobRoot+BlobParam(search)} target='_self' component="Navigation" className={"pageNavLink home t-track-custom"}  dataTag={"Navigation-_-Click-_-Home"} dataModal={`Exit_Lang`} linkName={t("Home")} contentId="interstitial"/>
                                :
                                <NavLink id='home' to={ lobRoot+BlobParam(search) } data-component="Navigation" className="pageNavLink home t-track-custom" dangerouslySetInnerHTML={{ __html: "Home" }} onClick={openSubNav} data-bactmln="Navigation-_-Click-_-Home"/>
                                }
                            </li>
                            
                            {
                                categoryDemoData && categoryDemoData.map(category => (
                                /* compared currentUrl to category.path and then demo path to set active state on Navigation */
                                    <li key={category.path} className={`nav-item${ demoCatNameSs === category.path ?
                                        ' active' : category.submenu[demoType] && category.submenu[demoType].find(sublink => sublink.path === demoCatNameSs) ? ' active' : '' }`}>
                                        <button id="Back_Home" data-component="Navigation" className="back-to-parent" onClick={showHomeMenu} aria-label={t('navigation_modal.button.back_home_menu')}>
                                            <img src={`${process.env.PUBLIC_URL}/assets/icons/arrow-expand.svg`} alt={t('navigation_modal.button.back_home_menu')} />
                                        </button>
                                        {i18n.language === 'es' && category.lang !=='es' ? <Modal url={`${process.env.PUBLIC_URL}`+lobDemoSplit+'/'+ category.path+BlobParam(search)} target='_self' lang={category.lang + '-US'} hrefLang={category.lang + '-US'} component="Navigation" className={`t-track-body-copy-link pageNavLink${(category.path) === '/' ? ' home' : ''}`}  dataTag={`Navigation-_-Hyperlink-_-"`+category.path} dataModal={`Exit_Lang`} linkName={t(category.name)} contentId="interstitial"/>
                                        :
                                        <h2 className="pageNavLink-heading"><NavLink lang={category.lang + '-US'} hrefLang={category.lang + '-US'} id={category.path} to={lobDemoSplit+'/'+ category.path+BlobParam(search)} data-component="Navigation" className={`t-track-body-copy-link pageNavLink${(category.path) === '/' ? ' home' : ''}`} dangerouslySetInnerHTML={{ __html: category.name }} onClick={openSubNav} aria-haspopup={category.submenu[demoType]?.length ? 'true' : 'false' } data-bactmln={"Navigation-_-Hyperlink-_-"+category.path}/></h2>
                                        }
                                        { category.submenu[SELECTORS.MOBILE_DEMO] &&
                                            category.submenu[SELECTORS.MOBILE_DEMO].length > 0 &&
                                            <Fragment>
                                                <h3 className="navs--link-header" dangerouslySetInnerHTML={{ __html: t('navigation_modal.banking.mobile') }} />
                                                <ul className="subnav" aria-label="submenu">
                                                {
                                                    category.submenu[SELECTORS.MOBILE_DEMO].map((sublink, i) => (
                                                        // Display Sub-Navigation based on the language selected
                                                        <li key={i} className="subnav-item">
                                                            {i18n.language === 'es' && sublink.lang !=='es' ? 
                                                                <Modal url={sublink.key==='related' ? sublink.link : `${process.env.PUBLIC_URL}`+lobDemoSplit+'/'+sublink.path+BlobParam(search)} target={sublink.key==='related' ? '_blank' : '_self'} lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} component="SubNavigation" className="t-track-body-copy-link pageNavLink"  dataTag={`Navigation-_-Hyperlink-_-"`+sublink.path} dataModal={`Exit_Lang`} linkName={t(sublink.title)} contentId="interstitial"/>
                                                                : sublink.key !=='related' ?
                                                                    <NavLink lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} id={sublink.path} to={sublink.path+BlobParam(search)} data-component="SubNavigation" className="t-track-body-copy-link pageNavLink" dangerouslySetInnerHTML={{ __html: sublink.title }} onClick={movePagetoTop} data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} />
                                                            :
                                                            <a id={sublink.path} data-component="SubNavigation" className="t-track-body-copy-link related-link pageNavLink" href={sublink.link} target='_blank' data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} rel="noopener noreferrer">{sublink.title}</a>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                                </ul>
                                            </Fragment>
                                        }

                                        
                                        { category.submenu[SELECTORS.ONLINE_DEMO] &&
                                            category.submenu[SELECTORS.ONLINE_DEMO].length > 0 &&
                                            <Fragment>
                                                <h3 className="navs--link-header" dangerouslySetInnerHTML={{ __html: t('navigation_modal.banking.online') }} />
                                                <ul className="subnav" aria-label="submenu">
                                                {
                                                    category.submenu[SELECTORS.ONLINE_DEMO].map((sublink, i) => (
                                                        // Display Sub-Navigation based on the language selected
                                                        <li key={i} className="subnav-item">
                                                            {i18n.language === 'es' && sublink.lang !=='es' ? 
                                                                <Modal url={sublink.key==='related' ? sublink.link : `${process.env.PUBLIC_URL}`+lobDemoSplit+'/'+sublink.path+BlobParam(search)} target={sublink.key==='related' ? '_blank' : '_self'} lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} component="SubNavigation" className="t-track-body-copy-link pageNavLink"  dataTag={`Navigation-_-Hyperlink-_-"`+sublink.path} dataModal={`Exit_Lang`} linkName={t(sublink.title)} contentId="interstitial"/>
                                                                : sublink.key !=='related' ?
                                                                    <NavLink lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} id={sublink.path} to={sublink.path+BlobParam(search)} data-component="SubNavigation" className="t-track-body-copy-link pageNavLink" dangerouslySetInnerHTML={{ __html: sublink.title }} onClick={movePagetoTop} data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} />
                                                            :
                                                            <a id={sublink.path} data-component="SubNavigation" className="t-track-body-copy-link related-link pageNavLink" href={sublink.link} target='_blank' data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} rel="noopener noreferrer">{sublink.title}</a>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                                </ul>
                                            </Fragment>
                                        }


                                        { category.submenu[SELECTORS.MPOS_DEMO] &&
                                            category.submenu[SELECTORS.MPOS_DEMO].length > 0 &&
                                            <Fragment>
                                                <h3 className="navs--link-header" dangerouslySetInnerHTML={{ __html: t('navigation_modal.banking.mpos') }} />
                                                <ul className="subnav" aria-label="submenu">
                                                {
                                                    category.submenu[SELECTORS.MPOS_DEMO].map((sublink, i) => (
                                                        // Display Sub-Navigation based on the language selected
                                                        <li key={i} className="subnav-item">
                                                            {i18n.language === 'es' && sublink.lang !=='es' ? 
                                                                <Modal url={`${process.env.PUBLIC_URL}`+lobDemoSplit+'/'+sublink.path+BlobParam(search)} target={sublink.key==='related' ? '_blank' : '_self'} lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} component="SubNavigation" className="t-track-body-copy-link pageNavLink"  dataTag={`Navigation-_-Hyperlink-_-"`+sublink.path} dataModal={`Exit_Lang`} linkName={t(sublink.title)} contentId="interstitial"/>
                                                                : sublink.key !=='related' ?
                                                                    <NavLink lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} id={sublink.path} to={sublink.path+BlobParam(search)} data-component="SubNavigation" className="t-track-body-copy-link pageNavLink" dangerouslySetInnerHTML={{ __html: sublink.title }} onClick={movePagetoTop} data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} />
                                                            :
                                                            <a id={sublink.path} data-component="SubNavigation" className="t-track-body-copy-link related-link pageNavLink" href={sublink.link} target='_blank' data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} rel="noopener noreferrer">{sublink.title}</a>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                                </ul>
                                            </Fragment>
                                        }


                                        { category.submenu[SELECTORS.ESSENTIALS_DEMO] &&
                                            category.submenu[SELECTORS.ESSENTIALS_DEMO].length > 0 &&
                                            <Fragment>
                                                <h3 className="navs--link-header" dangerouslySetInnerHTML={{ __html: t('navigation_modal.banking.essentials') }} />
                                                <ul className="subnav" aria-label="submenu">
                                                {
                                                    category.submenu[SELECTORS.ESSENTIALS_DEMO].map((sublink, i) => (
                                                        // Display Sub-Navigation based on the language selected
                                                        <li key={i} className="subnav-item">
                                                            {i18n.language === 'es' && sublink.lang !=='es' ? 
                                                                <Modal url={`${process.env.PUBLIC_URL}`+lobDemoSplit+'/'+sublink.path+BlobParam(search)} target={sublink.key==='related' ? '_blank' : '_self'} lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} component="SubNavigation" className="t-track-body-copy-link pageNavLink"  dataTag={`Navigation-_-Hyperlink-_-"`+sublink.path} dataModal={`Exit_Lang`} linkName={t(sublink.title)} contentId="interstitial"/>
                                                                : sublink.key !=='related' ?
                                                                    <NavLink lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} id={sublink.path} to={sublink.path+BlobParam(search)} data-component="SubNavigation" className="t-track-body-copy-link pageNavLink" dangerouslySetInnerHTML={{ __html: sublink.title }} onClick={movePagetoTop} data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} />
                                                            :
                                                            <a id={sublink.path} data-component="SubNavigation" className="t-track-body-copy-link related-link pageNavLink" href={sublink.link} target='_blank' data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} rel="noopener noreferrer">{sublink.title}</a>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                                </ul>
                                            </Fragment>
                                        }

                                        { category.submenu[SELECTORS.RESTAURANT_DEMO] &&
                                            category.submenu[SELECTORS.RESTAURANT_DEMO].length > 0 &&
                                            <Fragment>
                                                <h3 className="navs--link-header" dangerouslySetInnerHTML={{ __html: t('navigation_modal.banking.restaurant') }} />
                                                <ul className="subnav" aria-label="submenu">
                                                {
                                                    category.submenu[SELECTORS.RESTAURANT_DEMO].map((sublink, i) => (
                                                        // Display Sub-Navigation based on the language selected
                                                        <li key={i} className="subnav-item">
                                                            {i18n.language === 'es' && sublink.lang !=='es' ? 
                                                                <Modal url={`${process.env.PUBLIC_URL}`+lobDemoSplit+'/'+sublink.path+BlobParam(search)} target={sublink.key==='related' ? '_blank' : '_self'} lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} component="SubNavigation" className="t-track-body-copy-link pageNavLink"  dataTag={`Navigation-_-Hyperlink-_-"`+sublink.path} dataModal={`Exit_Lang`} linkName={t(sublink.title)} contentId="interstitial"/>
                                                                : sublink.key !=='related' ?
                                                                    <NavLink lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} id={sublink.path} to={sublink.path+BlobParam(search)} data-component="SubNavigation" className="t-track-body-copy-link pageNavLink" dangerouslySetInnerHTML={{ __html: sublink.title }} onClick={movePagetoTop} data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} />
                                                            :
                                                            <a id={sublink.path} data-component="SubNavigation" className="t-track-body-copy-link related-link pageNavLink" href={sublink.link} target='_blank' data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} rel="noopener noreferrer">{sublink.title}</a>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                                </ul>
                                            </Fragment>
                                        }

                                        { category.submenu[SELECTORS.RETAIL_DEMO] &&
                                            category.submenu[SELECTORS.RETAIL_DEMO].length > 0 &&
                                            <Fragment>
                                                <h3 className="navs--link-header" dangerouslySetInnerHTML={{ __html: t('navigation_modal.banking.retail') }} />
                                                <ul className="subnav" aria-label="submenu">
                                                {
                                                    category.submenu[SELECTORS.RETAIL_DEMO].map((sublink, i) => (
                                                        // Display Sub-Navigation based on the language selected
                                                        <li key={i} className="subnav-item">
                                                            {i18n.language === 'es' && sublink.lang !=='es' ? 
                                                                <Modal url={`${process.env.PUBLIC_URL}`+lobDemoSplit+'/'+sublink.path+BlobParam(search)} target={sublink.key==='related' ? '_blank' : '_self'} lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} component="SubNavigation" className="t-track-body-copy-link pageNavLink"  dataTag={`Navigation-_-Hyperlink-_-"`+sublink.path} dataModal={`Exit_Lang`} linkName={t(sublink.title)} contentId="interstitial"/>
                                                                : sublink.key !=='related' ?
                                                                    <NavLink lang={sublink.lang + '-US'} hrefLang={sublink.lang + '-US'} id={sublink.path} to={sublink.path+BlobParam(search)} data-component="SubNavigation" className="t-track-body-copy-link pageNavLink" dangerouslySetInnerHTML={{ __html: sublink.title }} onClick={movePagetoTop} data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} />
                                                            :
                                                            <a id={sublink.path} data-component="SubNavigation" className="t-track-body-copy-link related-link pageNavLink" href={sublink.link} target='_blank' data-bactmln={"Navigation-_-Hyperlink-_-"+sublink.path} rel="noopener noreferrer">{sublink.title}</a>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                                </ul>
                                            </Fragment>
                                        }
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </ReactModal>
        </Fragment>
    );
};

export default NavigationModal;